import { Result, ok, err } from '@xlearn/common';
import { Time, defaultTime, TimeInterval, defaultTimeInterval } from '../../api';

export type InteractionType = 'true-false' | 'choice' | 'fill-in' | 'long-fill-in' | 'matching' | 'performance' | 'sequencing' | 'likert' | 'numeric' | 'other';

export function parseInteractionType(value: string): Result<InteractionType, false> {
  switch (value) {
    case 'true-false':
    case 'choice':
    case 'fill-in':
    case 'long-fill-in':
    case 'matching':
    case 'performance':
    case 'sequencing':
    case 'likert':
    case 'numeric':
    case 'other':
      return ok(value);
    default:
      return err(false);
  }
}

export type InteractionResult = 'correct' | 'incorrect' | 'unanticipated' | 'neutral' | number;

export function parseInteractionResult(value: string): Result<InteractionResult, false> {
  switch (value) {
    case 'correct':
    case 'incorrect':
    case 'unanticipated':
    case 'neutral':
      return ok(value);
    default:
      const num = parseFloat(value);
      if (isNaN(num)) {
        return err(false);
      }

      return ok(num);
  }
}

export function defaultInteraction(): Interaction {
  return {
    id: '',
    type: 'other',
    // objectives: [],
    timestamp: defaultTime(),
    // correctResponses: [],
    // weighting: 1,
    learnerResponse: '',
    result: 'neutral',
    latency: defaultTimeInterval(),
    description: ''
  };
}

export interface Interaction {
  id: string;
  type: InteractionType;
  // objectives: {
  //   id: string
  // }[]
  timestamp: Time;
  // correctResponses: {
  //   pattern: string
  // }[],
  // weighting: number
  learnerResponse: string;
  result: 'correct' | 'incorrect' | 'unanticipated' | 'neutral' | number;
  latency: TimeInterval;
  description: string;
}
